<app-admin-list
  buttonText="Agregar menú"
  [buttonUrl]="buttonUrl"
  description="Selecciona uno de tus menús para acceder a sus detalles."
  icon="menu_book"
  [list]="menus | fromMenusToListItem : businessId"
  noDataText="Todavía no tienes menús agregados."
>
</app-admin-list>
